import { type SxProps } from '@mui/material/styles';
import MUITextField from '@mui/material/TextField';
import * as React from 'react';
import { ChangeEvent, Ref } from 'react';

export interface TextInputProps {
  placeholder?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  InputPropsStyle?: SxProps;
  sx?: SxProps;
  error?: string;
  type?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  inputRef?: Ref<HTMLElement>;
}
const TextInput = ({
  placeholder = '',
  onChange,
  value,
  sx,
  InputPropsStyle,
  error,
  type = 'text',
  disabled = false,
  autoFocus = false,
  inputRef
}: TextInputProps) => {
  return (
    <MUITextField
      inputRef={inputRef}
      InputProps={{
        sx: InputPropsStyle
      }}
      sx={sx}
      value={value}
      type={type}
      placeholder={placeholder}
      onChange={onChange}
      error={!!error}
      helperText={error}
      autoFocus={autoFocus}
      disabled={disabled}
    />
  );
};

export default TextInput;
